import { render, staticRenderFns } from "./Archived.vue?vue&type=template&id=c6bedcb8&scoped=true"
import script from "./Archived.vue?vue&type=script&lang=js"
export * from "./Archived.vue?vue&type=script&lang=js"
import style0 from "./Archived.vue?vue&type=style&index=0&id=c6bedcb8&lang=scss&scoped=true"
import style1 from "./Archived.vue?vue&type=style&index=1&id=c6bedcb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bedcb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6bedcb8')) {
      api.createRecord('c6bedcb8', component.options)
    } else {
      api.reload('c6bedcb8', component.options)
    }
    module.hot.accept("./Archived.vue?vue&type=template&id=c6bedcb8&scoped=true", function () {
      api.rerender('c6bedcb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Archived.vue"
export default component.exports